"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelGroupCollapsible = void 0;
var _react = _interopRequireDefault(require("react"));
var _PanelGroup = _interopRequireDefault(require("react-bootstrap/lib/PanelGroup"));
var _panelCollapsible = require("./panel-collapsible");
var PanelGroupCollapsible = exports.PanelGroupCollapsible = function PanelGroupCollapsible(_ref) {
  var panels = _ref.panels,
    _ref$accordion = _ref.accordion,
    accordion = _ref$accordion === void 0 ? false : _ref$accordion,
    _ref$allWithCaret = _ref.allWithCaret,
    allWithCaret = _ref$allWithCaret === void 0 ? false : _ref$allWithCaret;
  return /*#__PURE__*/_react["default"].createElement(_PanelGroup["default"], {
    accordion: accordion,
    id: "panel-group-collapsible"
  }, panels.map(function (panel, id) {
    var key = "panel".concat(id);
    var title = panel.title,
      body = panel.body,
      withCaret = panel.withCaret;
    return /*#__PURE__*/_react["default"].createElement(_panelCollapsible.PanelCollapsible, {
      title: title,
      withCaret: withCaret || allWithCaret,
      eventKey: accordion ? key : undefined,
      key: key
    }, body);
  }));
};